const state = {
  asideMenuCollapse: false
}
const getters = {
  asideMenuCollapse: state => state.asideMenuCollapse
}

const mutations = {
  'setAsideMenuCollapse' (state, statem) {
    console.log('setAsideMenuCollapse', statem)
    state.asideMenuCollapse = statem;
  }
}
console.log(getters, 'getters')
export default{
  state,
  getters,
  mutations
}
// export const state = { asideMenuCollapse: false, };

// export function setAsideMenuCollapse(payload) {
//   state.asideMenuCollapse = payload;
// }



// WEBPACK FOOTER //
// ./src/store/utils/index.js